import React from "react";

/**
 * Emoji reaction to a previous message. Structured data lives in
 * `message.metadata.reaction = { emoji, messageId }`. An empty emoji means the
 * reaction was removed.
 */
const ReactionMessage = ({ message }) => {
  const emoji = message.metadata?.reaction?.emoji || "";
  return (
    <span className="wa-msg__reaction">
      {emoji ? (
        <>
          <span className="wa-msg__reaction-emoji">{emoji}</span>
          <span>Reacted to a message</span>
        </>
      ) : (
        <span>Removed their reaction</span>
      )}
    </span>
  );
};

export default ReactionMessage;
